import React from 'react'
import { ReactFormGenerator } from "react-form-builder2";
import { Boxed } from "./Boxed.components";
import "react-form-builder2/dist/app.css";
import styled from 'styled-components';
import { Theme } from '../utils/theme';


const StyledGenerator = styled.div`
 padding : 10px 0;

 .react-form-builder-form .rfb-item .row { 
  border: 0;
  border-radius: 0;
  padding: 0;
 }

 .react-form-builder-form .rfb-item label{ 
    margin-bottom: 2.5px;

    span { 
    font-size : ${Theme.SecondaryFontSize};
    font-weight : 600;
    background: transparent;
    color: ${Theme.PrimaryTextColor}
  }
 }


`
export const GenerateForm = (props) => {
    return ( 
      <StyledGenerator>
        <ReactFormGenerator
          form_action=""
          form_method="POST"
          hide_actions={true}
          {...props}
        />
      </StyledGenerator>
    );
  };